import { useQuery } from '@tanstack/react-query'

import { getRequest } from 'src/lib/api-client'
import { queries } from 'src/lib/query-keys'
import type { Consumer } from 'src/shared/features/consumers/schemas/consumer'

export const getConsumerById = (consumerId: string) => getRequest<Consumer>(`/consumers/${consumerId}`)

export const useConsumerById = (consumerId: string) => {
  return useQuery({
    queryKey: [queries.consumers.detail(consumerId).queryKey],
    queryFn: async () => {
      const response = await getConsumerById(consumerId)

      if (!response) {
        throw new Error(`Consumer data for ID ${consumerId} is undefined`)
      }
      return response
    },
    retry: 1,
    staleTime: 15 * 60 * 1000, // 15 minutes
    refetchOnWindowFocus: false,
    enabled: !!consumerId,
  })
}
